export const config = {
  // devApiUrl: "http://localhost:8080/api/v1",
  devApiUrl: "https://dev.agrabiz.de/api/v1",
  prodApiUrl: "https://web.agrabiz.de/api/v1",
  authUrl: "https://us-central1-agrabiz-monitor-tool-2c4a5.cloudfunctions.net/api",
};

